import { SHOW_ALERT, SHOW_ALERT_INIT } from "./actionTypes";

export const showAlert = (message) => {
  return {
    type: SHOW_ALERT,
    message,
  };
};

export const showAlertInit = () => {
  return {
    type: SHOW_ALERT_INIT,
    message: null,
  };
};
